import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import api, { extractNextUrlPath } from '../utils/api';
import ServiceCard from '../components/ServiceCard';
import SEOHead from '../components/SEOHead';
import './Services.css';

const Services = () => {
  const { t, i18n } = useTranslation();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchServices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchServices = async () => {
    try {
      setLoading(true);
      setError('');
      
      // Fetch all pages if paginated
      let allServices = [];
      let nextUrl = '/services/';
      
      while (nextUrl) {
        const response = await api.get(nextUrl);
        
        const services = response.data.results || response.data || [];
        allServices = [...allServices, ...services];
        
        if (response.data.next) {
          nextUrl = extractNextUrlPath(response.data.next);
        } else {
          nextUrl = null;
        }
      }
      
      setServices(allServices);
    } catch (err) {
      let errorMessage = 'Failed to load services';
      
      if (err.response) {
        // Server responded with error status
        const status = err.response.status;
        if (status === 404) {
          errorMessage = 'Services endpoint not found';
        } else if (status === 500) {
          errorMessage = 'Server error. Please try again later';
        } else if (status === 403) {
          errorMessage = 'Access denied';
        } else {
          errorMessage = `Failed to load services (${status})`;
        }
      } else if (err.request) {
        // Request was made but no response received
        errorMessage = 'Unable to connect to server. Please check your connection';
      } else {
        // Error setting up the request
        errorMessage = `Error: ${err.message}`;
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };


  if (loading) {
    return <div className="container"><div className="loading">{t('common.loading')}</div></div>;
  }

  if (error) {
    return <div className="container"><div className="error-message">{error}</div></div>;
  }

  return (
    <div className="services-page">
      <SEOHead
        title="Production Services | GFM Studio"
        description="Explore GFM Studio's production, streaming, and broadcast services."
        path="/services"
      />
      <div className="container">
        <h1 className="page-title">
          {i18n.language === 'ka' ? 'ჩვენი სერვისები' : 'Our Services'}
        </h1>
        
        {services.length === 0 ? (
          <p>{i18n.language === 'ka' ? 'სერვისები არ არის ხელმისაწვდომი' : 'No services available at the moment.'}</p>
        ) : (
          <div className="services-grid">
            {services.map(service => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Services;

